import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import extend from 'lodash/extend'
import { theme, fonts, FONT_WEIGHTS } from '../../../style'

const TAGS = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    p: 'p',
    span: 'span',
    b: 'b',
}

const LETTER_SPACINGS = {
    Z: 0,
    S: 1,
    M: 1.5,
    L: 2,
    XL: 4,
    XXL: 8,
}

const Text = ({
    children,
    tag: Tag,
    size,
    space,
    color: clr,
    bold,
    semibold,
    medium,
    center,
    underline,
    uppercase,
    style: styl,
    ...rest
}) => {
    if (1 * bold + 1 * semibold + 1 * medium > 1) {
        throw new Error('bold, semibold or medium, only one can be set to true')
    }

    const baseStyle = { backgroundColor: theme.transparent }

    // In case size is unknown, fallback to 'M'
    const font = get(fonts, size, fonts.M)
    // ^ { fontWeight: ..., fontSize: ..., lineHeight: ... }

    // In case color is unknown, fallback to 'magenta'
    const color = clr ? get(theme, clr, 'magenta') : theme.black
    const textAlign = center ? 'center' : 'left'
    const style = {
        ...baseStyle,
        ...font,
        color,
        textAlign,
        letterSpacing: LETTER_SPACINGS[space],
        margin: 0,
    }

    if (bold) {
        style.fontWeight = FONT_WEIGHTS.bold
    }

    if (semibold) {
        style.fontWeight = FONT_WEIGHTS.semibold
    }

    if (medium) {
        style.fontWeight = FONT_WEIGHTS.medium
    }

    if (underline) {
        extend(style, {
            textDecorationLine: 'underline',
            textDecorationStyle: 'solid',
            textDecorationColor: color,
        })
    }

    if (uppercase) {
        style.textTransform = 'uppercase'
    }

    return (
        <Tag style={{ ...style, ...styl }} {...rest}>
            {children}
        </Tag>
    )
}

Text.sizes = Object.keys(fonts)
Text.spaces = Object.keys(LETTER_SPACINGS)
Text.colors = Object.keys(theme)

Text.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node,
    ]).isRequired,
    tag: PropTypes.oneOf(Object.keys(TAGS)),
    size: PropTypes.oneOf(Object.keys(fonts)),
    space: PropTypes.oneOf(Object.keys(LETTER_SPACINGS)),
    color: PropTypes.oneOf(Object.keys(theme)),
    bold: PropTypes.bool,
    semibold: PropTypes.bool,
    medium: PropTypes.bool,
    center: PropTypes.bool,
    underline: PropTypes.bool,
    uppercase: PropTypes.bool,
    style: PropTypes.object, // eslint-disable-line
    // Plus all other props associated to native text comp
}

Text.defaultProps = {
    tag: 'p',
    size: 'M',
    space: 'Z',
    color: 'dark',
    bold: false,
    semibold: false,
    medium: false,
    center: false,
    underline: false,
    uppercase: false,
    style: {},
}

export default Text
